import { useState, type FormEvent } from 'react'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

interface CobaltOnboardingDialogProps {
  open: boolean
  isStarting: boolean
  onOpenChange: (open: boolean) => void
  onContinue: (emrInstanceDomain: string) => void
}

export function CobaltOnboardingDialog({
  open,
  isStarting,
  onOpenChange,
  onContinue,
}: CobaltOnboardingDialogProps) {
  const [domain, setDomain] = useState('')

  const submit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    onContinue(domain.trim().replace(/\/$/, ''))
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <form className="grid gap-4" onSubmit={submit}>
          <DialogHeader>
            <DialogTitle>Connect eClinicalWorks through Cobalt</DialogTitle>
            <DialogDescription>
              Enter the web address your organization uses to sign in to
              eClinicalWorks. Cobalt needs it when creating a new organization.
            </DialogDescription>
          </DialogHeader>

          <div className="grid gap-2">
            <Label htmlFor="cobalt-emr-domain">eClinicalWorks URL</Label>
            <Input
              id="cobalt-emr-domain"
              name="emr_instance_domain"
              type="url"
              inputMode="url"
              autoComplete="url"
              placeholder="https://mypractice.example.com"
              value={domain}
              disabled={isStarting}
              required
              pattern="https://.*"
              onChange={(event) => setDomain(event.target.value)}
            />
          </div>

          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              disabled={isStarting}
              onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button type="submit" disabled={isStarting}>
              {isStarting ? 'Opening…' : 'Continue to Cobalt'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
